import { generateClient } from "aws-amplify/api";

const client = generateClient();

import { list_user_guide_main_modules } from '@/graphql/queries'

export default {
  data() {
    return {
      UserGuideLists: [],
    }
  },
  methods: {
    async fetchUserGuideMainList() {
      try {
        const response = await client.graphql({
          query: list_user_guide_main_modules,
          variables: {
            input: { 
              guide_topic_status:'ALL'
            }
          }
        })
        let responseData = JSON.parse(response.data.list_user_guide_main_modules)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.UserGuideLists = responseData.data || []
        } else {
          this.UserGuideLists = []
        }
        // console.log(this.UserGuideLists)
      } catch (error) {
        console.error("Error fetching Testimonials:", error);
        this.UserGuideLists = [];
        throw error;
      }
    },
  },
};
